import PostPassword from '@components/post-password/script';
import { atempl as endpoints } from '@api/v0/fetch/.endpoints';
import atnlConsolePrint from '@resources/atnl-console-print/atnlConsolePrint';
import CookieBar from '@components/cookie-bar/script';
import MediaWidthObserver from '@resources/media-width-observer/MediaWidthObserver';
import { SwiperSetup } from '@resources/swiper-setup/SwiperSetup';
import Menu from '@components/topbar/script.js';

import '@components/atnl-select/script';
import '@components/single-video/script';
import '@components/single-staff/script';
import '@components/ten-by-ten/script';
import '@components/book/script';

import '@blocks/blocks.scripts';

atnlConsolePrint();
SwiperSetup.init();
endpoints.init();


new PostPassword();
new CookieBar();
new MediaWidthObserver();
new Menu();
